module.exports = __webpack_public_path__ + "static/media/cluster-terminology-2.431d017e.jpg";